import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instancepi2bbb0csu5f as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance2rx62p874ogj4 as Phases_getInstance,
} from './request/HttpRequestPipeline.mjs';
import {
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance39l8b4mzhgwzm as Phases_getInstance_0,
} from './statement/HttpResponsePipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstancedvtd2m29fslb as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from './engine/HttpClientEngineBase.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpClient$slambda(this$0) {
  return constructCallableReference(($this$intercept, call, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.check' call
    if (!(call instanceof HttpClientCall())) {
      var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
      throw IllegalStateException().o(toString(message));
    }
    var response = yield* this$0.q5j_1.v4v(Unit_instance, call.a5k(), $completion);
    call.b5k(response);
    yield* $this$intercept.y4u(call, $completion);
    return Unit_instance;
  }), 2);
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
function HttpClient$slambda_0(this$0) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    try {
      yield* $this$intercept.z4u($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        this$0.t5j_1.e4x(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.w4v_1.a5k(), cause));
        throw cause;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 2);
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      constructor(engine, userConfig) {
        return new.target.c5k(engine, userConfig);
      }
      static c5k(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.h5j_1 = engine;
        $this.i5j_1 = userConfig;
        $this.j5j_1 = false;
        $this.k5j_1 = atomic$boolean$1(false);
        $this.l5j_1 = Job($this.h5j_1.ww().cd(Key_instance));
        $this.m5j_1 = $this.h5j_1.ww().in($this.l5j_1);
        $this.n5j_1 = new (HttpRequestPipeline())();
        $this.o5j_1 = new (HttpResponsePipeline())();
        $this.p5j_1 = new (HttpSendPipeline())();
        $this.q5j_1 = new (HttpReceivePipeline())();
        $this.r5j_1 = AttributesJsFn(true);
        $this.s5j_1 = $this.h5j_1.d5k();
        $this.t5j_1 = new (Events())();
        $this.u5j_1 = new (HttpClientConfig())();
        $this.h5j_1.e5k($this);
        var tmp = Phases_getInstance().j5k_1;
        $this.p5j_1.a4w(tmp, HttpClient$slambda($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.i5j_1;
        $this.u5j_1.s5k(get_HttpRequestLifecycle());
        $this.u5j_1.s5k(get_BodyProgress());
        $this.u5j_1.s5k(get_SaveBody());
        if ($this$with.p5k_1) {
          $this.u5j_1.t5k('DefaultTransformers', HttpClient$lambda);
        }
        $this.u5j_1.s5k(Plugin_getInstance());
        $this.u5j_1.s5k(get_HttpCallValidator());
        if ($this$with.o5k_1) {
          $this.u5j_1.s5k(get_HttpRedirect());
        }
        $this.u5j_1.u5k($this$with);
        if ($this$with.p5k_1) {
          $this.u5j_1.s5k(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.u5j_1);
        $this.u5j_1.e5k($this);
        var tmp_0 = Phases_getInstance_0().v5k_1;
        $this.o5j_1.a4w(tmp_0, HttpClient$slambda_0($this));
        return $this;
      }
      static a5l(engine, userConfig, manageEngine) {
        var $this = this.c5k(engine, userConfig);
        $this.j5j_1 = manageEngine;
        if ($this.j5j_1) {
          if (engine instanceof HttpClientEngineBase()) {
            engine.d5l_1.atomicfu$incrementAndGet();
          }
          var tmp = ensureNotNull($this.m5j_1.cd(Key_instance));
          tmp.zx((cause) => {
            var tmp;
            if (!(engine instanceof HttpClientEngineBase())) {
              tmp = true;
            } else {
              tmp = engine.d5l_1.atomicfu$decrementAndGet() <= 0;
            }
            var shouldClose = tmp;
            var tmp_0;
            if (shouldClose) {
              var tmp_1;
              if (cause == null) {
                engine.m6();
                tmp_1 = Unit_instance;
              } else {
                var tmp0_elvis_lhs = cause instanceof CancellationException() ? cause : null;
                cancel(engine, tmp0_elvis_lhs == null ? CancellationException().p('Client scope is canceled', cause) : tmp0_elvis_lhs);
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            return Unit_instance;
          });
        }
        return $this;
      }
      ww() {
        return this.m5j_1;
      }
      *g5l(builder, $completion) {
        this.t5j_1.e4x(get_HttpRequestCreated(), builder);
        var tmp = yield* this.n5j_1.v4v(builder, builder.k5l_1, $completion);
        return tmp instanceof HttpClientCall() ? tmp : THROW_CCE();
      }
      m6() {
        var success = this.k5j_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.r5j_1.i4q(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.p4q().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var plugin = installedFeatures.i4q(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.m6();
          }
        }
        this.l5j_1.o13();
      }
      toString() {
        return 'HttpClient[' + toString(this.h5j_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().a5l(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.n5l(config.n5k_1);
  return HttpClient().a5l(engine, config, true);
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
